import { queryInitStatClientConfig } from '@/pages/aigc/constants/server';
import { RequrstBack } from '@/pages/aigc/types/server';
import http from '@/pages/globalpedia/utils/httpTS';
import { useRequest } from 'ahooks';
import { isArray, isEmpty, sortBy } from 'lodash-es';

// 获取产品编辑的Studio筛选器数据
export const useGetEditProductStudioList = <T>(
  params?: T,
  isNewStudio = false,
) => {
  const fetch = () =>
    http({
      url: '/api/v1/globalpedia_pc/pipeline/studios_add',
      method: 'GET',
      data: params,
    }) as RequrstBack;
  const data = useRequest(fetch, {
    ...queryInitStatClientConfig,
    refreshDeps: [params],
    cacheKey: 'studioList',
    loadingDelay: 300,
    onSuccess: result => {
      if (isArray(result) && !isEmpty(result)) {
        // a-z排序
        const sortStudioList: any = sortBy(
          result,
          (o: { name: string; }) => o.name,
        )?.map((t: any) => {
          if (isNewStudio) {
            return {
              text: t?.name,
              value: `${t?.name}/${t?.id}`,
              pteam: t?.pteam,
              studio_location_city: t?.studio_location_city,
              studio_location_country: t?.studio_location_country,
            };
          }
          return {
            text: t?.name,
            value: `${t?.name}/${t?.id}`,
          };
        });
        // 成功修改数据源
        data?.mutate(sortStudioList);
      }
    },
  });
  return {
    ...data,
  };
};

// 编辑Project Info
export const useEditProjectDetailInfo = <
  T extends 'infoEdit' | 'similarEdit' | 'VisualEdit',
>(
  paramsKey: T,
) => {
  const editConfigUrl =
    {
      infoEdit: '/api/v1/globalpedia_pc/project/info_edit',
      similarEdit: '/api/v1/globalpedia_pc/project/similar_edit',
      VisualEdit: '/api/v1/globalpedia_pc/project/visual_edit',
    }[paramsKey as string] || '';
  const fetch = <O>(mutateParams: O) =>
    http({
      url: editConfigUrl,
      method: 'POST',
      data: mutateParams,
    }) as RequrstBack;
  const data = useRequest(fetch, {
    ...queryInitStatClientConfig,
    refreshDeps: [paramsKey],
    cacheKey: 'editInfo',
    manual: true,
    retryCount: 0,
  });
  return {
    ...data,
  };
};
